import React from "react";
import { allStatuses, AllStatusesEnum } from "./constants";

export const Statuses = ({ status }) => {
  const backgroundColor =
      AllStatusesEnum?.[status] === AllStatusesEnum.ACTIVE
      ? "#ECFDF5"
      : AllStatusesEnum?.[status] === AllStatusesEnum.INACTIVE
        ? "#F3F4F6"
        : "#FFFBEB";

  const color =
      AllStatusesEnum?.[status] === AllStatusesEnum.ACTIVE
      ? "#059669"
      : AllStatusesEnum?.[status] === AllStatusesEnum.INACTIVE
        ? "#374151"
        : "#D97706";

  return (
    status && (
      <div
        className="main-statuses-wrapper"
        style={{
          background: backgroundColor,
          color: color,
        }}
      >
        <div
          className="main-statuses-round"
          style={{
            background: color,
          }}
        />
        {allStatuses?.[status]}
      </div>
    )
  );
};
